export interface HeroSlide {
  id: string;
  kind: "film" | "news";
  badge: string;
  meta: string;
  title: string;
  description: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "guitou-12",
    kind: "film",
    badge: "焦点短片 · 剧情",
    meta: "林致远 / 12 分钟 / 2026-10-12",
    title: "归途",
    description: "一辆夜班大巴，载着三个不肯说话的人，驶向同一个县城。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20night%20bus%20driving%20on%20an%20empty%20highway%2C%20rain%20streaked%20windows%20glowing%20warm%20amber%2C%20headlights%20cutting%20through%20mist%2C%20deep%20teal%20night%20sky%2C%20moody%20atmospheric%20film%20still%2C%20anamorphic%20lens%20flare&width=1400&height=800&seq=hero-guitou-a1&orientation=landscape",
  },
  {
    id: "niguang-feixing",
    kind: "film",
    badge: "编辑推荐 · 科幻",
    meta: "何知白 / 15 分钟 / 2026-10-03",
    title: "逆光飞行",
    description: "太阳熄灭前的最后七十二小时，人类决定把记忆发射出去。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20sci%20fi%20film%20still%20of%20a%20rocket%20launch%20tower%20silhouetted%20against%20a%20burning%20orange%20dusk%20sky%2C%20dust%20and%20haze%2C%20industrial%20structures%2C%20tiny%20human%20figure%20looking%20up%2C%20dramatic%20cinematic%20lighting&width=1400&height=800&seq=hero-niguang-a2&orientation=landscape",
  },
  {
    id: "forum-2026-shortfilm",
    kind: "news",
    badge: "行业新闻",
    meta: "2026-10-16 · 编辑部",
    title: "短片正在成为行业的新入口",
    description: "2026 影视短片创作论坛落幕，三百多位从业者讨论短片工业化与出海。",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20creative%20industry%20conference%20hall%20with%20a%20large%20glowing%20screen%2C%20blurred%20audience%20silhouettes%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20editorial%20photography%2C%20cinematic%20depth%20of%20field&width=1400&height=800&seq=hero-forum-a3&orientation=landscape",
  },
  {
    id: "wusheng-hechang",
    kind: "film",
    badge: "高分纪录片",
    meta: "叶静川 / 17 分钟 / 2026-08-14",
    title: "无声的合唱",
    description: "一群听不见的人，组成了一支合唱团，用看得见的掌声回应。",
    image:
      "https://readdy.ai/api/search-image?query=Emotional%20documentary%20film%20still%20of%20a%20choir%20on%20stage%20under%20a%20single%20warm%20spotlight%2C%20hands%20raised%20in%20sign%20language%2C%20dark%20auditorium%2C%20soft%20golden%20haze%2C%20cinematic%20contrast&width=1400&height=800&seq=hero-hechang-a4&orientation=landscape",
  },
  {
    id: "zhiyuan",
    kind: "film",
    badge: "动画精选",
    meta: "苏念 / 5 分钟 / 2026-09-20",
    title: "纸鸢",
    description: "风筝飞走的那天，爷爷终于学会了放手。全片没有一句对白。",
    image:
      "https://readdy.ai/api/search-image?query=Hand%20painted%20animation%20still%20of%20a%20paper%20kite%20flying%20high%20above%20traditional%20tiled%20rooftops%2C%20warm%20afternoon%20sunlight%2C%20soft%20clouds%20and%20dust%20particles%2C%20delicate%20ink%20wash%20texture%2C%20nostalgic%20warm%20palette&width=1400&height=800&seq=hero-zhiyuan-a5&orientation=landscape",
  },
];

export interface CategoryEntry {
  type: string;
  title: string;
  description: string;
  icon: string;
  image: string;
}

export const categoryEntries: CategoryEntry[] = [
  {
    type: "剧情",
    title: "剧情",
    description: "普通人的裂缝与光亮",
    icon: "ri-heart-3-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20close%20up%20still%20of%20a%20person%20standing%20by%20a%20rain%20covered%20window%20in%20soft%20warm%20light%2C%20reflective%20melancholic%20mood%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20muted%20earth%20tones&width=600&height=400&seq=cat-drama-b1&orientation=landscape",
  },
  {
    type: "动画",
    title: "动画",
    description: "手绘笔触里的想象力",
    icon: "ri-palette-line",
    image:
      "https://readdy.ai/api/search-image?query=Whimsical%20hand%20painted%20animation%20still%20of%20floating%20islands%20and%20paper%20lanterns%20in%20a%20soft%20peach%20sky%2C%20storybook%20illustration%20texture%2C%20gentle%20light%2C%20dreamy%20color%20palette&width=600&height=400&seq=cat-animation-b2&orientation=landscape",
  },
  {
    type: "纪录片",
    title: "纪录片",
    description: "真实的人，真实的时间",
    icon: "ri-camera-lens-line",
    image:
      "https://readdy.ai/api/search-image?query=Documentary%20photograph%20of%20a%20small%20town%20alley%20at%20golden%20hour%2C%20an%20elderly%20person%20sitting%20by%20the%20door%2C%20warm%20dusty%20sunlight%2C%20authentic%20everyday%20life%2C%20natural%20film%20grain&width=600&height=400&seq=cat-doc-b3&orientation=landscape",
  },
  {
    type: "科幻",
    title: "科幻",
    description: "在别处发生的明天",
    icon: "ri-planet-line",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20sci%20fi%20still%20of%20a%20vast%20desert%20landscape%20under%20two%20moons%20with%20a%20distant%20lone%20structure%2C%20hazy%20warm%20orange%20sky%2C%20cinematic%20minimal%20composition%2C%20subtle%20dust%20particles&width=600&height=400&seq=cat-scifi-b4&orientation=landscape",
  },
  {
    type: "喜剧",
    title: "喜剧",
    description: "生活里那些荒诞的时刻",
    icon: "ri-emotion-laugh-line",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20playful%20cinematic%20still%20of%20an%20empty%20office%20hallway%20with%20scattered%20papers%20and%20a%20rolling%20chair%2C%20warm%20sunlight%20through%20blinds%2C%20quirky%20composition%2C%20clean%20modern%20interior&width=600&height=400&seq=cat-comedy-b5&orientation=landscape",
  },
];

export const siteHighlights = [
  { label: "精选短片", value: "14", unit: "部" },
  { label: "影视资讯", value: "10", unit: "条" },
  { label: "覆盖类型", value: "5", unit: "类" },
  { label: "每周更新", value: "3", unit: "次" },
];